import React, { useEffect, useRef } from "react";
import useProgressiveImg from "../../utils/imageLoader";
import styles from "../../styles/Banner.module.scss";

export const ParallaxImage = (props) => {
  const {
    bannerStyle,
    lowResDesktopImage,
    responsiveImage,
    alt
  } = props;
  const [src, { blur }] = useProgressiveImg(
    lowResDesktopImage,
    responsiveImage
  );

  const ref = useRef();

  const useScrollHandler = (handler) => {
    useEffect(() => {
      window.addEventListener("scroll", handler);
      return () => {
        window.removeEventListener("scroll", handler);
      };
    });
  };

  const handler = () => {
    ref.current.style.transform = `translateY(${window.pageYOffset * 0.5}px)`;
  };
  useScrollHandler(handler);

  return (
    <div className={styles.parallaxContainer}>
      <img
        className={styles.parallax}
        ref={ref}
        src={src}
        alt={alt || responsiveImage}
        style={{
          paddingTop: bannerStyle && `${bannerStyle.paddingTop}`,
          filter: blur ? "blur(20px)" : "none",
          transition: blur ? "none" : "filter 0.3s ease-out",
        }}
      />
    </div>
  );
};
